/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType';
import { FxIdDomainEntitiesDocumentsDocumentGeoFromJSON, FxIdDomainEntitiesDocumentsDocumentGeoToJSON, } from './FxIdDomainEntitiesDocumentsDocumentGeo';
import { FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON, FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON, } from './FxIdDomainEntitiesDocumentsGameDocumentVersion';
/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsDocument interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsDocument(value) {
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    if (!('DocumentType' in value) || value['DocumentType'] === undefined)
        return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined)
        return false;
    if (!('IsActive' in value) || value['IsActive'] === undefined)
        return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('Geo' in value) || value['Geo'] === undefined)
        return false;
    if (!('Versions' in value) || value['Versions'] === undefined)
        return false;
    return true;
}
export function FxIdDomainEntitiesDocumentsDocumentFromJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Id': json['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON(json['DocumentType']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'IsActive': json['IsActive'],
        'GameSystemName': json['GameSystemName'],
        'Geo': FxIdDomainEntitiesDocumentsDocumentGeoFromJSON(json['Geo']),
        'Versions': (json['Versions'].map(FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON)),
    };
}
export function FxIdDomainEntitiesDocumentsDocumentToJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON(value['DocumentType']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'IsActive': value['IsActive'],
        'GameSystemName': value['GameSystemName'],
        'Geo': FxIdDomainEntitiesDocumentsDocumentGeoToJSON(value['Geo']),
        'Versions': (value['Versions'].map(FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON)),
    };
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsDocument.js.map